import axios from "axios";
import React from "react";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const useAcubeService = () => {
  const _axios = axios.create();

  _axios.interceptors.request.use(async (config) => {
    return config;
  });

  const postProxy = React.useCallback(
    (url, data) => {
      return _axios
        .post(`${API_BASE_URL}${url}`, data)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          throw new Error(err.response.data.message);
        });
    },
    [_axios]
  );

  const putProxy = React.useCallback(
    (url, data) => {
      return _axios
        .put(`${API_BASE_URL}${url}`, data)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          if (err.response.data.message) {
            throw new Error(err.response.data.message);
          } else {
            return err.response ? err.response.data : err;
          }
        });
    },
    [_axios]
  );

  const getProxy = React.useCallback(
    (url) => {
      return _axios
        .get(`${API_BASE_URL}${url}`)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    [_axios]
  );

  const deleteProxy = React.useCallback(
    (url, data) => {
      return _axios
        .delete(`${API_BASE_URL}${url}`, { data })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return err.response ? err.response.data : err;
        });
    },
    [_axios]
  );

  return { postProxy, getProxy, putProxy, deleteProxy };
};
